export default {
  zh: {
    official: "官网首页",
    language: "多语言",
    chinese: "中文",
    english: "英文",
    alreadyHave: "已有账号",
    goLogin: "直接登录",
    logOut: "安全退出",
    tableTipe: "暂无内容",
    reference: "参考网址:",
    recommend: "常用类型推荐:",
    yes: "是",
    no: "否",
    operation: "操作",
    required: "[必选]",
    regular: {
      error: "格式错误",
      email: "格式错误",
      phone: "支持数字",
      amount: "金额格式错误",
      vcode: "支持长度为4位或6位的数字",
      password: "支持8-16位数字和字母的组合",
      enName: "支持字母和空格组成",
      english: "支持英文",
    },
    placeholder: {
      enter: "请输入",
      select: "请选择",
      currency: "币种",
      Amount: "金额",
      replenish: "请补充",
      upload: "请上传",
      check: "请勾选",
      nonage: "必须年满18岁",
      specify: "请列明",
      toEdit: "去编辑",
      inquiryOrder: "订单查询中...",
      noOrder: "暂无订单",
      noData: "无数据",
      prefix: "请选择前缀",
      selectCurrency: "请选择币种",
    },
    button: {
      search: "搜索",
      creation: "创建",
      save: "保存",
      last: "上一步",
      next: "下一步",
      submit: "提交",
      addMore: "添加更多",
      affirm: "确认",
      view: "查看",
      edit: "编辑",
      delete: "删除",
      capital: "修改股本信息",
      back: "返回当前表单",
    },
    hint: {
      title: "提示",
      save: "保存之后将不可修改，确定要保存吗？",
      quit: "确定要退出吗?",
      switch: "切换语言将刷新网页，确定要切换吗？",
      leave: "离开将丢失已编辑的内容，确定离开吗？",
      unfinished: "内容保存中，离开可能会丢失已编辑的内容，确定离开吗？",
      pay: "您还未完成支付，确定要离开吗？",
      remove: "确定移除吗？",
      createForm: "创建申请之后将不可修改，确定要创建吗？",
      submitOrder: "若您选择“提交”，相关申请信息将被视为填写完毕，提交后不可修改。 您确定提交并跟进后续的付款吗？",
    },
    warning: {
      fundsName: "请选择相关基金",
      ratio: "请输入所占股份数量",
      capital: "请输入注册资本",
      paidInCapital: "请输入实收资本",
      trust: "请输入信托名称",
      otherCause: "请输入其他原因",
      otherSource: "请输入其他来源",
      customModule: "请添加自定义套餐中的服务模块",
      shareholder: "请输入股东名称",
      uploadSize: "上传文件大小不能超过5MB",
      alreadySubmit: "申请已提交，禁止修改",
      havePaid: "您已经支付过了",
      supplement: "请完善信息后，再支付",
      closed: "订单已关闭",
      minimum01: "至少添加1个股东",
      minimum02: "至少添加1个股东和1个董事",
    },
    error: {
      server: "服务器内部错误",
      timeout: "请求超时，请稍后重试",
      disconnect: "无法连接到服务器，请检查网络",
      login: "登录失效，请重新登录",
      request: "请求失败",
      lack: "缺少参数[code]",
      scarce: "缺少参数，请重新进入",
      notAllow: "该订单已经创建，禁止修改",
      upload: "上传失败",
      loginToken: "无法获取登录令牌",
      stepNone: "当前申请不存在该步骤，请重新进入",
    },
    info: {
      emailSend: "验证邮件已发送，请注意查收!",
    },
    success: {
      save: "保存成功",
      submit: "提交成功",
      pay: "支付成功",
      know: "知道了",
      change: "修改成功",
      remove: "移除成功",
    },
  },
  en: {
    official: "Official website",
    language: "Languages",
    chinese: "Chinese",
    english: "English",
    alreadyHave: "Already have an account",
    goLogin: "Sign in",
    logOut: "Log out",
    tableTipe: "No content",
    reference: "Refer to the website:",
    recommend: "Recommended Common Types:",
    yes: "Yes",
    no: "No",
    operation: "Action",
    required: "[Required]",
    regular: {
      error: "Format error",
      email: "Format error",
      phone: "Support digital",
      amount: "Amount format error",
      vcode: "The value can contain four or six digits",
      password: "Supports the combination of 8 to 16 digits and letters",
      enName: "Letters and Spaces are supported",
      english: "Support English",
    },
    placeholder: {
      enter: "Please enter",
      select: "Please select",
      currency: "Currency",
      Amount: "Amount",
      replenish: "Please add",
      upload: "Please upload",
      check: "Please select",
      nonage: "Must be at least 18 years old",
      specify: "Please specify",
      toEdit: "To edit",
      inquiryOrder: "Order inquiry in progress ...",
      noOrder: "No order",
      noData: "No data",
      prefix: "Please select prefix",
      selectCurrency: "Please select currency",
    },
    button: {
      search: "Search",
      creation: "Creation",
      save: "Save",
      last: "Previous",
      next: "Next",
      submit: "Submit",
      addMore: "Add more",
      affirm: "Confirm",
      view: "View",
      edit: "Edit",
      delete: "Delete",
      capital: "Modify",
      back: "Go back",
    },
    hint: {
      title: "Reminder",
      save: "After saving, it cannot be modified. Are you sure you want to save it?",
      quit: "Are you sure you want out?",
      switch: "If you switch the language without saving, the info will be lost. Will you switch the language?",
      leave: "If you leave without saving, the info will be lost. Will you leave?",
      unfinished: "Saving in progress. Leaving this page may result in the loss of your changes. Are you sure you want to leave?",
      pay: "You haven't finished the payment yet. Are you sure you want to leave?",
      remove: "Are you sure to remove it?",
      createForm: "This page cannot be modified after creation. Will you continue with the application?",
      submitOrder: "The application info will be deemed complete and cannot be modified after submission. Will you continue and proceed for payment?",
    },
    warning: {
      fundsName: "Please select the related fund",
      ratio: "Please enter the number of shares held",
      capital: "Please enter the registered capital",
      paidInCapital: "Please enter the Paid-up capital",
      trust: "Please enter the trust name",
      otherCause: "Please enter another reason",
      otherSource: "Please enter another source",
      customModule: "Add a service module in a Customize",
      shareholder: "Please enter shareholder name",
      uploadSize: "Upload file size cannot exceed 5MB",
      alreadySubmit: "The application has been submitted and no modification is allowed",
      havePaid: "You have already paid",
      supplement: "Please complete the information before payment",
      closed: "Order closed",
      minimum01: "Add at least 1 shareholder",
      minimum02: "Add at least 1 shareholder and 1 director",
    },
    error: {
      server: "Internal server error",
      timeout: "Request timed out, please try again later",
      disconnect: "Unable to connect to the server, please check the network",
      login: "Login invalid, please log in again",
      request: "The request failed",
      lack: "Missing parameter[code]",
      scarce: "Missing parameter, please re-enter",
      notAllow: "The order has been created and cannot be modified",
      upload: "Fail to upload",
      loginToken: "Failed to obtain the login token",
      stepNone: "This step does not exist in the current application. Please re-enter",
    },
    info: {
      emailSend: "The verification email has been sent, please note to check!",
    },
    success: {
      save: "Save successfully",
      submit: "Submit successfully",
      pay: "Payment success",
      know: "Understand",
      change: "Modify successfully",
      remove: "Remove successfully",
    },
  },
};
